export function htmlToPlainText(html?: string): string {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const items = Array.from(doc.querySelectorAll('li'))
    .map((li: HTMLLIElement): string => li.textContent?.trim() ?? '')
    .filter(Boolean);
  if (!items.length) return (doc.body.textContent ?? '').trim();
  return items.join(', ');
}

export function generateRandomBase64(): string {
  return typeof crypto !== 'undefined' && crypto.getRandomValues
    ? btoa(String.fromCharCode(...crypto.getRandomValues(new Uint8Array(16))))
    : 'k74aNNuM6JBhUhPg7ti6Ug==';
}
